import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { userActivityService } from '../services/userActivityService';

// Custom hook to track page navigation in React Router
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page visit whenever location changes
    userActivityService.trackPageVisit(location.pathname);
  }, [location.pathname]);

  return location;
};

export default usePageTracking; 